export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Libera o arquivo da memória; o download já começou.
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

const OPME_PLAN_TEMPLATE: Record<string, string> = {
  BRADESCO:   "bradesco_opme",
  AMIL:       "amil_opme",
  UNIMED:     "unimed_opme",
  SULAMERICA: "sulamerica_opme",
  "PETROBRÁS":"petrobras_opme",
  LEVESAUDE:  "levesaude_opme",
};

export const opmeTemplateFor = (plan: string): string =>
  OPME_PLAN_TEMPLATE[plan] ?? "generic_template";